import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag"
import { windowUpdate, blueimpGalleryDestroy, removeReCaptchaBadge } from './shared/common'
import { resetCareerForm, updateFormSubmitState } from './career/careerform'
import { buildOwl, destroyOwl } from './shared/owlcarousel'
import { refreshWarLiveSearch } from './shared/war-live-search'
// controllers
import Controller from './controllers/Controller'
import AlumniFormController from './controllers/AlumniFormController'
import HomeScopeController from './controllers/HomeScopeController'
import LawyerFiltersController from './controllers/LawyerFiltersController'
import ReCaptchaController from './controllers/ReCaptchaController'
// views
import BasicView from './views/BasicView'
import ListView from './views/ListView'

const routes = {
  'basic': {
    controller: Controller,
    view: BasicView
  },
  'list': {
    controller: Controller,
    view: ListView
  },
  'home_scope': {
    controller: HomeScopeController,
    view: ListView
  },
  'lawyers_filter': {
    controller: LawyerFiltersController,
    view: null
  },
  'alumniform': {
    controller: AlumniFormController,
    view: null
  },
  'recptch': {
    controller: ReCaptchaController,
    view: null
  },
}

const aswapProps = {
  animationTimeHide: 600,
  animationTimeShow: 800,
  preloadOnHover: false,
  cacheOn: true,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    windowUpdate()
    buildOwl()
    refreshWarLiveSearch()
    WCAG.onViewChanged()
    RytmWebflow.showUp.rebuild()
    blueimpGalleryDestroy()
    updateFormSubmitState()
  },
  onViewHide: () => {
    WCAG.dialogCloseAll()
    RytmWebflow.showUp.hide()
    // removeReCaptchaBadge()
  },
  onViewHidden: () => {
    destroyOwl()
    resetCareerForm()
  }
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}